import { Component, OnInit } from '@angular/core';
import { UtilitiesService } from '../services/utilities.service';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import Swal from 'sweetalert2'
import { CommonService } from '../services/common.service';

@Component({
    selector: 'app-employees',
    templateUrl: './employees.component.html',
    styleUrls: ['./employees.component.css'],
    standalone: false
})
export class EmployeesComponent implements OnInit {

  page = 1;
  pageSize = 10;

  list_length = 0;
  items: any[] = [];
  leaves: any[] = [];
  users: any[] = [];
  token: any;

  item = {
    name: null,
    email: null,
    phone: null,
    address: null,
    work_location: null,
    account_number: null,
    bank_name: null,
    id_number: null,
    id_expiry_date: null,
    id_attachment: null,
    basic_salary: null,
    daily_allowance: null,
    hourly_overtime: null,
    status: 'ACTIVE'
  }

  new_item = {
    name: null,
    email: null,
    phone: null,
    address: null,
    country: null,
    account_number: null,
    bank_name: null,
    id_number: null,
    id_expiry_date: '',
    id_attachment: null,
    basic_salary: null,
    gender: '0',
    birth_date: '',
    user_id: null,
    status: null
  }

  employee_status = {
    status: null,
    status_from_date: null,
    status_to_date: null
  }

  employee_details: any;
  employeeName: any;
  files: any;

  leaves_months: any;

  new_item_id: number = 0;
  Swal = 'sweetalert2'

  constructor(public utility: UtilitiesService, private modalService: NgbModal, private api: ApiService, private route: ActivatedRoute, private common: CommonService) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let id = params['id'] != null ? params['id'] : null;
      this.getUser(id);
    });
  }

  open(content: any) {
    this.modalService.open(content);
  }

  open_employee_details(content: any, employee: any) {
    this.employee_details = employee;

    this.employee_details.status_date_from = employee.status_from_date;
    this.employee_details.status_date_to = employee.status_date_to;


    let item = this.leaves.find(i => i.id === this.employee_details.id);

    this.employee_details.anuual_leaves = item ? item?.ANNUAL : 0;
    this.employee_details.anuual_leaves_left = item ? item?.ANNUAL_LEFT : 0;
    this.employee_details.sick_leaves = item ? item?.SICK : 0;
    this.employee_details.sick_leaves_left = item ? item?.SICK_LEFT : 0;
    this.employee_details.personal_leaves = item ? item?.PERSONAL : 0;

    this.modalService.open(content, { windowClass: "myCustomModalClass" });
  }

  edit(content: any, employee: any) {
    //let employee = this.items.find(i => i.id === id);

    this.new_item_id = employee.id;
    this.new_item = employee;
    this.new_item.status = employee.status;
    this.employee_status.status = employee.status;

    var date = new Date(employee.id_expiry_date);
    var month = (date.getMonth() + 1).toString();
    var day = (date.getDate()).toString();

    if (+month < 10)
      month = '0' + month;

    if (+day < 10)
      day = '0' + day;

    this.new_item.id_expiry_date = date.getFullYear() + '-' + month + '-' + day;

    var date2 = new Date(employee.birth_date);
    var month2 = (date2.getMonth() + 1).toString();
    var day2 = (date2.getDate()).toString();

    if (+month2 < 10)
      month2 = '0' + month2;

    if (+day2 < 10)
      day2 = '0' + day2;

    this.new_item.birth_date = date2.getFullYear() + '-' + month2 + '-' + day2;

    this.modalService.open(content);
  }


  getUser(id?: any) {
    this.utility.loading = true;
    const sub = this.api.get('users/', this.token).subscribe(
      async data => {

        let objects: any = {
          users: []
        }
        objects = data;

        this.users = objects.users;
      },
      async error => { }
    );
    sub.add(() => { this.getItems(id); });
  }

  getItems(id?: any) {
    const sub = this.api.get('employees/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.items = objects;
        this.list_length = this.items.length;

        this.items.forEach((item) => {
          let user = this.users.find(i => i.id === item.user_id);
          item.username = user?.username;
          item.email = user?.email;
          item.phone = user?.phone;
          item.role_id = user?.role_id;
          item.role = this.get_role(user?.role_id);
          item.active = user?.active;
        });

        if (id)
          this.items = this.items.filter(i => i.user_id === id);
      },
      async error => { }
    );
    sub.add(() => { this.get_total_leaves_by_employee() });
  }

  get_role(id: any) {
    let roles = localStorage.getItem('roles');

    if (roles) {
      let _roles: any[] = JSON.parse(roles);
      return _roles.find(i => i.id === id)?.name;
    }
    else
      return null;
  }

  async OnSubmit() {
    const body = {
      name: this.item.name,
      email: this.item.email,
      phone: this.item.phone,
      address: this.item.address,
      work_location: this.item.work_location,
      account_number: this.item.account_number,
      bank_name: this.item.bank_name,
      id_number: this.item.id_number,
      id_expiry_date: this.item.id_expiry_date,
      id_attachment: this.item.id_attachment,
      basic_salary: this.item.basic_salary,
      daily_allowance: this.item.daily_allowance,
      daily_overtime: 0,
      hourly_overtime: this.item.hourly_overtime,
      status: this.item.status
    }

    const sub = this.api.post("employees/", body, this.token).subscribe(
      async data => {
        this.getItems();
        Swal.fire({
          title: 'Success!',
          text: 'Employee Created Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    sub.add(() => { this.common.getDoctors(); });
    this.modalService.dismissAll();
  }

  async onDelete(id: any) {
    if (confirm("Delete this Employee?")) {
      this.api.delete('employees/' + id, this.token).subscribe(
        async data => {
          this.getItems();
          Swal.fire({
            title: 'Success!',
            text: 'Employee Deleted Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
    }
  }

  async OnUpdate(id: any) {
    const body = {
      name: this.new_item.name,
      email: this.new_item.email,
      phone: this.new_item.phone,
      address: this.new_item.address,
      country: this.new_item.country,
      account_number: this.new_item.account_number,
      bank_name: this.new_item.bank_name,
      id_number: this.new_item.id_number,
      id_expiry_date: this.new_item.id_expiry_date,
      id_attachment: this.new_item.id_attachment,
      basic_salary: this.new_item.basic_salary,
      gender: this.new_item.gender,
      birth_date: this.new_item.birth_date,
      status: this.new_item.status,
      user_id: this.new_item.user_id
    }

    const sub = this.api.update("employees/" + id, body, this.token).subscribe(
      async data => {
        this.getItems();
        Swal.fire({
          title: 'Success!',
          text: 'Employee Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    sub.add(() => { this.common.getDoctors(); });
    this.modalService.dismissAll();
  }

  async updateStatus(id: any) {
    const body = {
      status: this.employee_status.status,
      status_from_date: this.employee_status.status_from_date,
      status_to_date: this.employee_status.status_to_date,
    }

    this.api.update(`employees/${id}/status`, body, this.token).subscribe(
      async data => {
        this.getItems();
        Swal.fire({
          title: 'Success!',
          text: 'Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  fileChange(event: any) {
    let fileList: FileList = event.target.files;
    this.files = fileList;
  }

  isAdmin() {
    let role = localStorage.getItem('role');

    if (role === 'admin')
      return true;
    return false;
  }

  filterFunction(items: any[]) {
    if (this.employeeName == null)
      return items.filter(i => i.name != 'Nehad AL-Qassabi' && i.name != 'PhysioLife Clinic');
    else
      return items.filter(i => i.id_number.toLowerCase() === this.employeeName.toLowerCase() || i.name.toLowerCase().indexOf(this.employeeName.toLowerCase()) >= 0 || i.phone.toString() === this.employeeName.toLowerCase() || i.work_location.toLowerCase().indexOf(this.employeeName.toLowerCase()) >= 0);
  }

  get_total_leaves_by_employee() {
    const sub = this.api.get('leaves/stats', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.leaves = objects;

        this.leaves.forEach((leave) => {
          this.leaves_months = this.monthsBetween(leave.updated_at);
        })
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; });
  }

  monthsBetween(value: any): number {
    const today = new Date();
    const date = new Date(value);

    // Get the year and month for today and the given date
    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth();
    const givenYear = date.getFullYear();
    const givenMonth = date.getMonth();

    // Calculate the difference in months
    const monthDifference = (todayYear - givenYear) * 12 + (todayMonth - givenMonth);

    return monthDifference;
  }

  update_balance(id: any) {

  }

  reset_balance(id: any) {
    Swal.fire({
      title: `last update was before ${this.leaves_months} months. Do you want to RESET employee (Anuual and Sick leave) balance?`,
      showCancelButton: true,
      icon: 'question',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        const sub = this.api.update(`leaves/balance/${id}/ANNUAL`, { leaves: 30 }, this.token).subscribe(
          async data => {
            const sub = this.api.update(`leaves/balance/${id}/SICK`, { leaves: 10 }, this.token).subscribe(
              async data => {
                Swal.fire({
                  title: 'Success!',
                  text: 'Leave Balance Updated Successfuly!',
                  icon: 'success',
                  confirmButtonText: 'Cool'
                })
              },
              async error => {
                Swal.fire({
                  title: 'Error!',
                  text: 'Something went wrong!',
                  icon: 'error',
                  confirmButtonText: 'Ok'
                });
              }
            );
          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );

        sub.add(() => { this.getUser(); });
      }
    });
  }
}
